<template>
    <v-app>
        <v-navigation-drawer app v-model="drawer" :mini-variant.sync="mini" permanent
            v-if="$vuetify.breakpoint.mdAndUp">
            <v-list-item class="px-2" v-if="!mini">
                <v-list-item-avatar>
                    <v-img :src="urlLogo"></v-img>
                </v-list-item-avatar>

                <v-list-item-title style="font-weight: 600;">{{ chatbotName }}</v-list-item-title>

                <v-btn icon @click.stop="mini = !mini">
                    <v-icon>mdi-menu-open</v-icon>
                </v-btn>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item v-for="item in visibleItems" :key="item.title" link v-on:click="item.action">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div v-if="conversations.length > 0 && !mini">
                <p class="ml-3 mt-2" style="font-size: small; font-weight: 500;">Conversations</p>
                <div v-for="(item) in conversations" :key="item.id_session">
                    <v-card style="height: fit-content; border-radius: 15px;" elevation="0" outlined
                        class="mt-3 ml-1 mr-1" @click="goToSession(item.id_session)">
                        <v-list-item>
                            <!-- Contenido del chatbot -->
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium" style="font-size: small;">
                                    {{ getTruncatedMessage(item.messages) }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="grey--text mt-1" style="font-size: smaller;">
                                    {{ formatDate(item.created_at) }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </div>
            </div>
        </v-navigation-drawer>

        <Header v-if="!loading" :dark="dark" :chatbotName="chatbotName" :background-color="backgroundColor" :id_chatbot="idChatBot" :userRefSessionId="userRefSessionId"  />
        <v-main app v-if="!loading">
            <chatMessages :chatbotName="chatbotName"  :backgroundColor="backgroundColor" :dark="dark" :idConversation="idConversation"
                :profileImage="urlLogo" :messages="messages" :id_chatbot="idChatBot" :adminContactFlag="adminContactFlag"
                 :welcomeMessage="welcomeMessage" />
        </v-main>
        <v-progress-circular
        class="mx-auto my-auto"
        indeterminate
        color="black"
        size="40"
        v-if="loading"
        ></v-progress-circular>
        <v-dialog v-model="privateChatbot" persistent max-width="370px">
            <v-card style="border-radius: 15px; height: fit-content; width: 370px; text-align: center;">
                <br>
                <p style="font-size: medium; font-weight: 600;"><v-icon color="black" class="mr-3">mdi-lock</v-icon>This
                    AI
                    Agent is private.</p>
                <br>
                <p class="mx-5">Please login in to your account so you can use it inside the ChatPro AI platform.</p>
                <br>
                <v-card-actions>
                    <v-btn rounded color="black" class="white--text mx-auto mb-3"
                        :href="'https://app.chatpro.pro/login'" target="_blank" style="width: 200px;">Login</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Header from '../components/chatComponentsHome/chatHeader.vue'
import chatMessages from '../components/chatComponentsSession/chatMessages.vue'
import axiosChat from "@/logic/B2C/register_chats_chatpro/axiosChat.js";
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

export default {
    name: 'ChatView',
    components: {
        Header,
        chatMessages,
    },

    data() {
        return {
            //get from url id
            urlLogo: "",
            chatbotName: "",
            backgroundColor: "",
            dark: true,
            backgroundColor2: "",
            dark2: true,
            language: '', //  🇺🇸 EN  🇪🇸 ES
            idChatBot: "",
            idUser: "",
            initialPrompt: "",
            createdAt: "",
            privateChatbot: null,
            adminContactFlag: false,

            //Form User
            idConversation: '',

            pageTitle: '',

            suggestedMessages: [],
            welcomeMessage: "",


            //messages
            messages: [],
            loading: true,
            userRefSessionId: "",
            drawer: true,
            items: [

                { title: '', icon: 'mdi-menu-close', action: () => { this.mini = false } },
                { title: 'New chat', icon: 'mdi-plus-circle-outline', action: () => { this.returnHome() } }
            ],
            mini: true,
            conversations: []

        }
    },

    watch: {
        pageTitle(newTitle) {
            document.title = newTitle || 'Powered by ChatPro AI';
        },

        '$route.params.idConversation': {
            handler: function(newId) {
                if (newId) {
                    this.loading = true; // Opcional: poner loading mientras carga el nuevo
                    this.idConversation = newId;
                    this.getConversationMessages(); // Llamamos al método
                }
            },
            immediate: true // Esto hace que se ejecute también la primera vez (reemplaza al created)
        }
    },

    async mounted() {
        this.loading = true //activa el loader
        this.idChatBot = this.$route.params.idChatbot

        const responseGetDataChatbot = await axiosChat.get_data_chatbot(this.$route.params.idChatbot)
        if (responseGetDataChatbot.data.code == "success" & responseGetDataChatbot.data.data != undefined) {
            //chatbot data
            // console.log("Chatbot data", responseGetDataChatbot.data.data);
            this.urlLogo = responseGetDataChatbot.data.data.url_logo;
            this.chatbotName = responseGetDataChatbot.data.data.chatbot_name;

            this.backgroundColor = responseGetDataChatbot.data.data.background_color_1;
            this.dark = responseGetDataChatbot.data.data.dark_1;
            this.backgroundColor2 = responseGetDataChatbot.data.data.background_color_2;
            this.dark2 = responseGetDataChatbot.data.data.dark_2;
            this.language = responseGetDataChatbot.data.data.language; //  🇺🇸 EN  🇪🇸 ES
            this.idUser = responseGetDataChatbot.data.data.id_user;
            this.initialPrompt = responseGetDataChatbot.data.data.initial_prompt;
            this.createdAt = responseGetDataChatbot.data.data.created_at;
            this.privateChatbot = responseGetDataChatbot.data.data.private;
            this.suggestedMessages = [...(responseGetDataChatbot.data.data.suggested_messages || [])]
            this.welcomeMessage = responseGetDataChatbot.data.data.welcome_message || "Hi, how can I help you?👋"
            
            //Favicon and Tab Name
            this.pageTitle = responseGetDataChatbot.data.data.chatbot_name + ' | Powered by ChatPro AI';
            this.updateFavicon(responseGetDataChatbot.data.data.url_logo);
            // this.userRefSessionId = responseGetDataChatbot.data.data.session_ref || ''
            // console.log(this.userRefSessionId)

            this.getRefSession()
            

            this.loading = false
        }
        else {
            //// console.log('error ó chatbot desconocido')
        }

    },

    computed: {
        // Esta propiedad devuelve una lista filtrada dependiendo del estado de 'mini'
        visibleItems() {
            if (!this.mini) {
                // Si es mini, devolvemos todo el array MENOS el primer elemento (índice 0)
                return this.items.slice(1);
            }
            // Si no es mini, devolvemos todos
            return this.items;
        }
    },


    methods: {
        updateFavicon(logoUrl) {
            const faviconUrl = logoUrl || 'https://d7nzzuxaahac2.cloudfront.net/web/generic_logo_chatpro_bot_purple.webp';

            // Eliminar favicon existente
            const existingFavicon = document.querySelector('link[rel="icon"]');
            if (existingFavicon) {
                existingFavicon.parentNode.removeChild(existingFavicon);
            }

            // Crear y agregar nuevo favicon
            const favicon = document.createElement('link');
            favicon.rel = 'icon';
            favicon.type = 'image/png';
            favicon.href = faviconUrl;
            document.head.appendChild(favicon);

            // console.log(`Favicon actualizado a: ${faviconUrl}`);
        },

        async getConversationsCookie(session_ref) {

            if (session_ref == null) {
                console.log("No ref_session found")
                this.loading = false
            }
            else {
                console.log(session_ref)
                const responseGetDataConversation = await axiosChat.get_conversations_user_cookie(session_ref)
                // console.log(responseGetDataConversation.data.data)
                this.conversations = responseGetDataConversation.data.data
                this.loading = false

            }
        },

        getRefSession() {
            let visitorKey = Cookies.get('visitor_key');
            if (!visitorKey) {
                visitorKey = uuidv4();
                Cookies.set('visitor_key', visitorKey, { expires: 365 });
                this.registerUser(visitorKey);
            } else {
                // console.log('Visitante recurrente con ID:', visitorKey);
                this.userRefSessionId = visitorKey
                this.getConversationsCookie(this.userRefSessionId)
            }
        },

        registerUser(visitorKey) {
            console.log('Registrando visitante:', visitorKey);
            this.userRefSessionId = visitorKey
        },


        formatDate(isoDate) {
            const date = new Date(isoDate);
            return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        },


        getTruncatedMessage(messages) {
            const lastMsg = messages
                .filter(m => m.uid === '001')
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
            if (!lastMsg) return '';
            return lastMsg.content.length > 45
                ? lastMsg.content.slice(0, 42) + '...'
                : lastMsg.content;
        },

        goToSession(id) {
            this.$router.push('/' + this.idChatBot + '/' + id);
        },

        returnHome() {
            window.location.href = 'https://ai.chatpro.pro/' + this.idChatBot
        },

        async getConversationMessages() {
            // Usamos this.idConversation (que ya se actualizó en el watcher o data)
            // Ojo: Asegúrate que idConversation tenga valor
            if(!this.idConversation) return;

            console.log('Fetching conversation:', this.idConversation);
            
            try {
                const responseGetConversation = await axiosChat.get_conversation(this.idConversation);
                
                if (responseGetConversation.data.code == "success") {
                    // Actualizamos los mensajes
                    this.messages = responseGetConversation.data.message.messages;
                    
                    // Lógica del contacto/admin
                    this.contact = responseGetConversation.data.message.contact;
                    if (this.contact === "Admin" || (this.contact && this.contact !== '')) {
                        this.adminContactFlag = true;
                    } else {
                        this.adminContactFlag = false;
                    }
                    
                    this.loading = false; // Desactivar loader si lo activaste
                }
            } catch (error) {
                console.error("Error fetching messages", error);
                this.loading = false;
            }
        }
    },

    async created() {


        this.idConversation = this.$route.params.idConversation

        //// console.log('GET Conversation: ' + this.$route.params.idConversation)
        //// console.log()
        const responseGetConversation = await axiosChat.get_conversation(this.$route.params.idConversation)
        console.log(responseGetConversation)
        if (responseGetConversation.data.code == "success") {
            // console.log(responseGetConversation.data)
            this.messages = responseGetConversation.data.message.messages
            this.contact = responseGetConversation.data.message.contact
            console.log(responseGetConversation.data.message.messages)

            if (this.contact === "Admin") {
                this.adminContactFlag = true;
            }
            else if (this.contact != '') {
                this.adminContactFlag = true;
            }
            else {
                this.adminContactFlag = false
            }
        }


    },

}
</script>